export var EventTextTypeModifiers;
(function (EventTextTypeModifiers) {
    EventTextTypeModifiers["modifierLeague"] = "league";
    EventTextTypeModifiers["modifierEachWay"] = "each-way";
    EventTextTypeModifiers["modifierTeamName"] = "team-name";
    EventTextTypeModifiers["modifierEventName"] = "event-name";
    EventTextTypeModifiers["modifierEachWayEventName"] = "each-way-event-name";
})(EventTextTypeModifiers || (EventTextTypeModifiers = {}));
//# sourceMappingURL=EventTextTypeModifiers.js.map